@if (!loading && !onboarding.loading$()) {
  @if (impersonation.state$().active) {
    <div class="impersonation-banner">
      <span>Currently impersonating {{ impersonation.state$().targetDisplayName || impersonation.state$().targetIdentityUserId }}</span>
      <button type="button" (click)="impersonation.stop()" [disabled]="impersonation.loading$()">Stop</button>
    </div>
  }
  @if(appAuthService.loggedIn$() && onboarding.hasIncomplete$() && !appAuthService.isAdmin) {
    <app-my-onboarding-progress [progress]="onboarding.progress$()"></app-my-onboarding-progress>
  }
  @else {
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  }
}
